import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { createUseStyles } from 'react-jss'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import registerLassoImage from 'assets/register-lasso.svg'
import { sansSerifFontFamily, serifFontFamily } from '../../utils/styles'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundImage: `url(${registerLassoImage})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    width: 350,
    height: 350,
    justifyContent: 'center',
    alignContent: 'center',
    alignSelf: 'center',
  },
  title: {
    color: '#ffffff',
    fontFamily: serifFontFamily,
    fontSize: 28,
    fontWeight: 700,
    lineHeight: '140%',
    letterSpacing: '0.01em',
    textAlign: 'center',
  },
  text: {
    color: 'rgba(255, 255, 255, 0.8)',
    fontFamily: sansSerifFontFamily,
    fontSize: 18,
    fontWeight: 700,
    lineHeight: '140%',
    letterSpacing: '0.01em',
    textAlign: 'center',
    paddingLeft: 40,
    paddingRight: 40,
  },
})

export const RegisterLasso = flowMax(
  addDisplayName('RegisterLasso'),
  addTranslationHelpers,
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ classes, t }) => (
    <div className={classes.container}>
      <h2 className={classes.title}>{t('logIn.content.title')}</h2>
      <p className={classes.text}>{t('logIn.content.text')}</p>
    </div>
  )
)
